import {
  enableProdMode,
  provideZoneChangeDetection,
  LOCALE_ID,
  importProvidersFrom,
  isDevMode,
  inject,
  provideAppInitializer,
} from '@angular/core';

import { environment } from './environments/environment';
import { CurrencyPipe } from '@angular/common';
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { authErrorInterceptor } from './app/common/auth.interceptor';
import { AppUpdateService } from './app/common/app-update.service';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideStore } from 'src/app/common/state/store';
import { GroupReducer } from './app/mini-apps/expense-app/store/reducers/group/group.reducer';
import { IncomeReducer } from './app/mini-apps/expense-app/store/reducers/income/income.reducer';
import { ExpenseReducer } from './app/mini-apps/expense-app/store/reducers/expenses/expenses.reducer';
import { IgnoreTagsReducer } from './app/mini-apps/expense-app/store/reducers/ignore-tags/ignore-tags.reducer';
import { GroupTagReducer } from './app/mini-apps/expense-app/store/reducers/group-tags/group-tags.reducer';
import { ReoccurringTrackReducer } from './app/mini-apps/expense-app/store/reducers/reoccurring-tracks/reoccurring-tracks.reducer';
import { IconUploadReducer } from './app/mini-apps/expense-app/store/reducers/icon-uploads/icon-upload.reducer';
import { BudgetDetailReducer } from './app/mini-apps/expense-app/store/reducers/budget-details/budget-details.reducer';
import { provideEffects } from 'src/app/common/state/effects';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideStoreDevtools } from 'src/app/common/state/devtools';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { provideNativeDateAdapter } from '@angular/material/core';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserAnimationsModule),
    provideStore(
      {
        groups: GroupReducer,
        income: IncomeReducer,
        trackers: ExpenseReducer,
        ignoreTags: IgnoreTagsReducer,
        groupTags: GroupTagReducer,
        reoccurringTracks: ReoccurringTrackReducer,
        iconUpload: IconUploadReducer,
        budgetDetails: BudgetDetailReducer,
      },
      {},
    ),
    provideEffects(),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: environment.production,
    }),
    provideRouter(routes, withHashLocation()),
    { provide: LOCALE_ID, useValue: 'en' },
    CurrencyPipe,
    provideNativeDateAdapter(),
    provideHttpClient(
      withInterceptors([authErrorInterceptor]),
      withInterceptorsFromDi(),
    ),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideAppInitializer(() => {
      inject(AppUpdateService).init();
    }),
  ],
}).catch((err) => console.error(err));
